import app from './feathers'
import { configStore } from '../stores/configStore'

const configService = app.service('hype-config')

const methods = {
    async create(data) {
        const res = await configService.create(data)
        configStore.set(res)
        return res
    },
    async get() {
        const configs = await configService.find()
        if (configs.data[0]) {
            configStore.set(configs.data[0])
        }
        return configs
    },
    async remove(id) {
        const res = await configService.remove(id)
        configStore.remove(res._id)
        return res
    },
}

export default methods
